import type { ReactNode } from 'react';

export const symbol_moving_ministry: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M70-120q-12.75 0-21.37-8.63Q40-137.25 40-150v-660q0-12.75 8.63-21.38Q57.25-840 70-840h500q12.75 0 21.38 8.62Q600-822.75 600-810v660q0 12.75-8.62 21.37Q582.75-120 570-120H371v-170H270v170H70Zm30-60h110v-170h221v170h109v-600H100v600Zm110-270h60v-60h-60v60Zm0-160h60v-60h-60v60Zm160 160h60v-60h-60v60Zm0-160h60v-60h-60v60ZM210-180v-170h221v170-170H210v170Zm438.63-321.5q8.62-8.5 21.37-8.5h135l-32-33q-8-9-8.5-21t8.5-21q9-9 21-9t21 9l84 84q9 9 9 21t-9 21l-84 84q-9 9-21 9t-21-9q-9-9-8.5-21t8.5-21l32-33H670q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Z"
		/>
	</svg>
);
